/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import BaseLogic from "../../utils/BaseLogic";
import { PolicyList } from "api/legal/models/policies";
import { fetchPoliciesByCountryCode } from "../../api/legal/policiesApi";
import { NoPolicyDataFound } from "../../api/legal/models/legal";

interface State {
  isLoading: boolean;
  policies: PolicyList | null;
  error: Error | null;
}

const DEFAULT_COUNTRY_CODE = "US";

export default class PoliciesLogic extends BaseLogic<State> {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      policies: null,
      error: null,
    };
  }

  async init(countryCode = DEFAULT_COUNTRY_CODE) {
    await this.fetchPoliciesByCountry(countryCode);
  }

  async fetchPoliciesByCountry(countryCode: string) {
    const { isLoading } = this.state;
    if (isLoading) return;

    this.setState({
      isLoading: true,
      error: null,
    });
    this.setState({ isLoading: true });

    try {
      const { response, error } = await fetchPoliciesByCountryCode(countryCode);
      if (error) throw error;
      if (!response || !response.data.length) throw new NoPolicyDataFound();
      await this.setState({
        policies: response.data,
      });
    } catch (error) {
      await this.setState({ error });
    } finally {
      await this.setState({ isLoading: false });
    }
  }
}
